import { AnimationConfigs } from "../types/animations";

export const ANIMATION_CONFIG: AnimationConfigs = {
  scrollRange: [0.2, 1],
  flashcards: {
    card1: { rotation: [20, -12], baseY: [-0, -270], baseX: [0, -540] },
    card2: { rotation: [-15, 15], baseY: [100, -220], baseX: [0, 540] },
    card3: { rotation: [-20, 9], baseY: [0, 270], baseX: [0, -540] },
    card4: { rotation: [20, -11], baseY: [80, 290], baseX: [0, 540] },
  },
  emoticons: {
    blessed: { rotation: [80, 0], baseY: [0, -340], baseX: [0, -250] },
    happy: { rotation: [80, 0], baseY: [0, -75], baseX: [0, -600] },
    smirk: { rotation: [80, 0], baseY: [0, 40], baseX: [0, 550] },
    surprised: { rotation: [80, 0], baseY: [0, -300], baseX: [0, 250] },
    wrigglyUp: { rotation: [80, 0], baseY: [80, 290], baseX: [0, -250] },
    wrigglyDown: { rotation: [80, 0], baseY: [80, 350], baseX: [0, 260] },
  },
};

export const FLASHCARD_TEXTS = [
  "No more cramming or messy notes. Stay ahead while others fall behind.",
  "Join now and start learning smarter before anyone else.",
  "Your future self will thank you for getting in early.",
  "Track your progress, stay organized, and actually retain what you learn.",
];

export const FLASHCARD_COLORS = ["#F6FA5E", "#DFF2FE", "#7BF1A8", "#DAB2FF"];
